// Article #4 featured image — hosted WebP asset (875x375)
export const FEATURED_IMAGE_BEST_POOL_DECK_MATERIALS_DATA_URI =
  "https://vibe.filesafe.space/1790702435770123164/assets/03515a00-b8cf-4d8f-a767-2e69eb02adaf.webp";
